var _a;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

// ===== GSAP from CDN =====
var gsap$3 = window.gsap;
var gsapWithCSS = window.gsap;
var ScrollTrigger = window.ScrollTrigger;
var Observer = window.Observer;
var TextPlugin = window.TextPlugin;

// Run ScrollTrigger.refresh() without letting it snap the page's scroll position.
// (refresh() can throw the page to the top when it recalculates pinned triggers.)
function safeRefresh() {
  if (!ScrollTrigger || !ScrollTrigger.refresh) return;
  var y = window.scrollY || window.pageYOffset || 0;
  ScrollTrigger.refresh();
  if (Math.abs((window.scrollY || 0) - y) > 2) {
    if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(y, { immediate: true, force: true });
    else window.scrollTo(0, y);
  }
}

// ===== Dropdown =====
document.addEventListener("DOMContentLoaded", () => {
  var _a2;
  const urlHash2 = (_a2 = location.hash) == null ? void 0 : _a2.slice(1);
  document.querySelectorAll("[data-dropdown]").forEach((button) => {
    const id = button.getAttribute("aria-controls");
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    const duration = Number(button.getAttribute("data-dropdown-duration") ?? 0.5);
    const show = () => {
      button.setAttribute("aria-expanded", "true");
      target.setAttribute("aria-hidden", "false");
      gsapWithCSS.fromTo(target, { height: 0, clearProps: "display" }, {
        height: "auto", duration,
        onComplete: () => { safeRefresh(); }
      });
    };
    const hide = (init22 = false) => {
      button.setAttribute("aria-expanded", "false");
      target.setAttribute("aria-hidden", "true");
      gsapWithCSS.to(target, {
        height: 0, duration: init22 ? 0 : duration, display: "none",
        // Skip the refresh on the initial (page-load) collapse — that's what
        // snapped the page to the top. Only refresh on genuine user toggles.
        onComplete: () => { if (!init22) safeRefresh(); }
      });
    };
    const toggle = () => {
      button.getAttribute("aria-expanded") === "false" ? show() : hide();
    };
    const init5 = () => {
      if (urlHash2) {
        if (button.getAttribute("data-dropdown-anchor") === urlHash2) {
          show();
        } else {
          hide(true);
          const parentNode = button.closest(".Dropdown__Item");
          if (parentNode) {
            const anchorTarget = parentNode.querySelector(`#${urlHash2}`);
            if (anchorTarget) {
              show();
              setTimeout(() => {
                anchorTarget.scrollIntoView({ behavior: "smooth" });
              }, 1e3);
            }
          }
        }
      } else if (button.getAttribute("aria-expanded") === "false") {
        hide(true);
      }
      button.addEventListener("click", toggle);
    };
    init5();
  });
});

// ===== Config & Media Query =====
var config3 = {
  pathPrefix: "mini_link_3",
  breakpoints: { medium: 768, middle: 1e3, wide: 1440 }
};
const config$1 = getDefaultExportFromCjs(config3);
const spQuery = window.matchMedia(`(max-width: ${config$1.breakpoints.medium}px)`);
const onChangeQuery = (mediaQueryList, callback) => {
  mediaQueryList.addEventListener("change", callback);
};

// ===== Nav Height =====
document.addEventListener("DOMContentLoaded", () => {
  const getNavHeight = () => {
    var _a2, _b;
    const commonHeaderHeight = ((_a2 = document.querySelector(".ly_SPheader")) == null ? void 0 : _a2.clientHeight) ?? 0;
    document.documentElement.style.setProperty("--common-header-height", `${commonHeaderHeight}px`);
    const localNavHeight = ((_b = document.querySelector("[data-local-nav]")) == null ? void 0 : _b.clientHeight) ?? 0;
    document.documentElement.style.setProperty("--local-nav-height", `${localNavHeight}px`);
  };
  getNavHeight();
  onChangeQuery(spQuery, getNavHeight);
});

// ===== Scroll Lock (lightweight inline replacement) =====
const scrollLockExports = {
  _locked: false,
  _scrollY: 0,
  disablePageScroll() {
    if (this._locked) return;
    this._scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    this._locked = true;
  },
  enablePageScroll() {
    if (!this._locked) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, this._scrollY);
    this._locked = false;
  }
};

// ===== MicroModal (lightweight inline replacement) =====
const MicroModal = {
  _activeModals: {},
  _configs: {},
  init(config) {
    config = config || {};
    const trigger = config.openTrigger || "data-micromodal-trigger";
    document.querySelectorAll(`[${trigger}]`).forEach((btn) => {
      const modalId = btn.getAttribute(trigger);
      if (!modalId) return;
      this._configs[modalId] = config;
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.show(modalId, config);
      });
    });
    document.querySelectorAll("[data-micromodal-close]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const modal = btn.closest(".modal, [aria-hidden]");
        if (modal && modal.id) this.close(modal.id);
      });
    });
  },
  show(modalId, config) {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    config = config || this._configs[modalId] || {};
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("is-open");
    this._activeModals[modalId] = modal;
    if (config.onShow) config.onShow(modal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal || e.target.hasAttribute("data-micromodal-close")) {
        this.close(modalId);
      }
    });
    const escHandler = (e) => {
      if (e.key === "Escape") {
        this.close(modalId);
        document.removeEventListener("keydown", escHandler);
      }
    };
    document.addEventListener("keydown", escHandler);
  },
  close(modalId) {
    const modal = this._activeModals[modalId] || document.getElementById(modalId);
    if (!modal) return;
    const config = this._configs[modalId] || {};
    modal.setAttribute("aria-hidden", "true");
    modal.classList.remove("is-open");
    if (config.onClose) config.onClose(modal);
    delete this._activeModals[modalId];
  }
};
window.MicroModal = MicroModal;
const l = MicroModal;

// ===== YouTube IFrame API =====
const tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
let players = {};

function onYouTubeIframeAPIReady() {
  document.querySelectorAll("[data-video-id]").forEach((video) => {
    const videoId = video.getAttribute("data-video-id");
    players[video.id || videoId] = new YT.Player(video, {
      videoId,
      playerVars: {
        playsinline: 1,
        ...video.hasAttribute("data-video-autoplay") && {
          rel: 0, controls: 0, modestbranding: 0, showinfo: 0
        }
      },
      events: {
        onReady: (event) => {
          if (video.hasAttribute("data-video-autoplay")) {
            event.target.mute();
            event.target.playVideo();
          }
        },
        onStateChange: (event) => {
          if (video.hasAttribute("data-video-autoplay")) {
            if (event.data === YT.PlayerState.PLAYING) {
              const poster = document.querySelector(`[data-video-poster=${video.getAttribute("data-video-autoplay")}]`);
              if (poster) poster.style.display = "none";
            } else if (event.data === YT.PlayerState.ENDED) {
              event.target.seekTo(0, true);
              event.target.playVideo();
            }
          }
        }
      }
    });
  });
}
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

// ===== Responsive image/poster sources =====
document.querySelectorAll("[data-src-pc][data-src-sp]").forEach((element) => {
  const changeSrc = (e) => {
    element.src = e.matches ? element.getAttribute("data-src-sp") : element.getAttribute("data-src-pc");
  };
  changeSrc(spQuery);
  onChangeQuery(spQuery, changeSrc);
});

document.querySelectorAll("[data-poster-pc][data-poster-sp]").forEach((element) => {
  const changePoster = (e) => {
    element.poster = e.matches ? element.getAttribute("data-poster-sp") : element.getAttribute("data-poster-pc");
  };
  changePoster(spQuery);
  onChangeQuery(spQuery, changePoster);
});

// ===== Video play/stop buttons =====
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-video-play]").forEach((button) => {
    button.addEventListener("click", () => {
      button.style.display = "none";
      const id = button.getAttribute("data-video-play");
      document.getElementById(id).style.visibility = "visible";
      players[id].mute();
      players[id].playVideo();
    });
  });
  document.querySelectorAll("[data-video-stop]").forEach((button) => {
    button.addEventListener("click", () => {
      players[button.getAttribute("data-video-stop")].stopVideo();
    });
  });
});

// ===== Video Modal =====
l.init({
  openTrigger: "data-video-modal-trigger",
  onShow: (modal) => {
    scrollLockExports.disablePageScroll();
    const id = modal.getAttribute("data-video-modal-play");
    if (players[id]) {
      players[id].mute();
      players[id].playVideo();
    }
  },
  onClose: (modal) => {
    scrollLockExports.enablePageScroll();
    const id = modal.getAttribute("data-video-modal-play");
    if (players[id]) players[id].stopVideo();
  }
});

// ===== Intro Video Play/Pause =====
document.addEventListener("DOMContentLoaded", () => {
  let isVideoPaused = false;
  const videoElement = document.querySelector(".IntroVideo__Video video");
  const playPauseBtnElement = document.querySelector(".IntroVideo__PlayPauseButton");
  if (playPauseBtnElement) {
    playPauseBtnElement.addEventListener("click", function() {
      if (isVideoPaused) {
        videoElement.play();
        isVideoPaused = false;
        playPauseBtnElement.dataset.videoPause = false;
      } else {
        videoElement.pause();
        isVideoPaused = true;
        playPauseBtnElement.dataset.videoPause = true;
      }
    });
  }
});

// ===== Generic MicroModal =====
l.init({
  onShow: (modal) => {
    scrollLockExports.disablePageScroll();
    modal.querySelectorAll('a[href*="#"]').forEach((element) => {
      element.addEventListener("click", () => { l.close(modal.id); });
    });
    const scrollable = modal.querySelector("[data-scroll-lock-scrollable]");
    if (scrollable) scrollable.scrollTop = 0;
  },
  onClose: () => {
    window.setTimeout(() => { scrollLockExports.enablePageScroll(); }, 500);
  }
});

document.querySelectorAll("[data-micromodal-trigger]").forEach((button) => {
  const target = button.getAttribute("data-micromodal-trigger");
  if (!target) return;
  button.setAttribute("aria-controls", target);
});

// ===== URL Hash Modal Trigger =====
const urlHash = (_a = location.hash) == null ? void 0 : _a.slice(1);
if (urlHash) {
  const hashTrigger = document.querySelector(`[data-micromodal-trigger=${urlHash}]`);
  if (hashTrigger && hashTrigger instanceof HTMLButtonElement) {
    hashTrigger.click();
  }
}

// ===== Pull-down Menu =====
const PULL_DOWN_BUTTON = document.querySelector(`[data-pulldown-trigger="pc"]`);
const PULL_DOWN_MENU = document.querySelector(`[data-pulldown-menu="pc"]`);
{
  const handleMenu = () => {
    if (!PULL_DOWN_BUTTON || !PULL_DOWN_MENU) return;
    if (PULL_DOWN_BUTTON.getAttribute("aria-expanded") === "true") {
      PULL_DOWN_MENU.setAttribute("aria-hidden", "true");
      PULL_DOWN_BUTTON.setAttribute("aria-expanded", "false");
    } else {
      PULL_DOWN_MENU.setAttribute("aria-hidden", "false");
      PULL_DOWN_BUTTON.setAttribute("aria-expanded", "true");
    }
  };
  PULL_DOWN_BUTTON && PULL_DOWN_BUTTON.addEventListener("click", handleMenu);

  const resetMenuStatus = () => {
    PULL_DOWN_BUTTON?.setAttribute("aria-expanded", "false");
    PULL_DOWN_MENU?.setAttribute("aria-hidden", "true");
  };
  document.addEventListener("focusin", (e) => {
    const target = e.target;
    if (target instanceof Node && !PULL_DOWN_MENU?.contains(target) && !PULL_DOWN_BUTTON?.contains(target)) {
      resetMenuStatus();
    }
  });
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") resetMenuStatus();
  });
  onChangeQuery(spQuery, resetMenuStatus);
}

// ===== Photo Card 3D Hover =====
document.querySelectorAll("[data-photo-image]").forEach((box) => {
  const img = box.querySelector("img");
  if (!img) return;
  const handleMove = (e) => {
    const x = img.clientWidth - e.offsetX * 2;
    const y = img.clientHeight - e.offsetY * 2;
    let rx = -1 * x / 10;
    let ry = y / 15;
    rx = Math.max(-45, Math.min(45, rx));
    ry = Math.max(-30, Math.min(30, ry));
    img.style.transform = `rotateY(${rx}deg) rotateX(${ry}deg)`;
  };
  const handleEnter = (e) => {
    e.preventDefault();
    img.classList.add("opening");
    setTimeout(() => img.classList.remove("opening"), 250);
  };
  const handleLeave = () => {
    img.classList.add("ending");
    img.style.transform = "rotateY(0deg) rotateX(0deg)";
    setTimeout(() => {
      img.classList.remove("ending");
      img.removeAttribute("style");
    }, 250);
  };
  box.addEventListener("mouseenter", handleEnter);
  box.addEventListener("mousemove", handleMove);
  box.addEventListener("mouseleave", handleLeave);
});

// ===== Auto-play videos =====
document.querySelectorAll("[data-video-autoplay]").forEach((video) => {
  if (video instanceof HTMLVideoElement) {
    try { video.play(); } catch {}
  }
});

// ===== Register GSAP Plugins =====
gsapWithCSS.registerPlugin(ScrollTrigger);
gsapWithCSS.registerPlugin(TextPlugin);

// ===== ScrollTrigger Animations =====
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(`
    body, main, [data-scroll-fade], [data-scroll-group], [data-scroll-pin],
    [data-scaling-image], [data-scroll-image], [data-air-studio-parallax-trigger],
    [data-sticky], [data-photo], [data-simple-print-trigger], [data-hero-movie-trigger],
    [data-result], [data-click-to-collage], [data-result-image]
  `).forEach((triggerElement) => {

    if (triggerElement.matches("[data-scroll-fade]")) {
      const startPosition = triggerElement.getAttribute("data-scroll-fade-start");
      ScrollTrigger.create({
        trigger: triggerElement,
        onEnter: () => {
          const isStaggered = triggerElement.matches(`[data-scroll-group] [data-scroll-fade]`) && !spQuery.matches;
          if (!isStaggered) {
            gsapWithCSS.set(triggerElement, { attr: { "data-scroll-fade": "show" } });
          }
        },
        start: startPosition || "top 70%",
        once: true
      });
    }

    if (triggerElement.matches("[data-scroll-group]")) {
      ScrollTrigger.create({
        trigger: triggerElement,
        onEnter: () => {
          if (!spQuery.matches) {
            gsapWithCSS.set(triggerElement.children, {
              attr: { "data-scroll-fade": "show" }, stagger: 0.2
            });
          }
        },
        start: "top 50%",
        once: true
      });
    }

    if (triggerElement.matches("[data-hero-movie-trigger]")) {
      gsapWithCSS.timeline({
        defaults: { duration: 1 },
        paused: true,
        scrollTrigger: {
          trigger: triggerElement,
          start: "top top",
          end: "bottom bottom",
          invalidateOnRefresh: true,
          scrub: true
        }
      })
      .set(`[data-hero-movie-area]`, { backgroundColor: `#ffd940` })
      .set(`[data-hero-image]`, { opacity: 1 })
      .set(`[data-hero-asset]`, { opacity: 0 })
      .set(`[data-hero-phone]`, { opacity: 0, transform: "scale(2.5)" })
      .set(`[data-hero-mini-link]`, { top: "-100%" })
      .set(`[data-hero-photo]`, { opacity: 0 })
      .set(`[data-hero-heading]`, { opacity: 0 })
      .to(`[data-hero-asset="1"]`, { opacity: 1, delay: 1 })
      .to(`[data-hero-asset="2"]`, { opacity: 1 }, "+=0.5")
      .to(`[data-hero-asset="3"]`, { opacity: 1 }, "+=0.5")
      .to(`[data-hero-asset="4"]`, { opacity: 1 }, "+=0.5")
      .to(`[data-hero-asset="5"]`, { opacity: 1 }, "+=0.5")
      .addPause("+=0.5")
      .to(`[data-hero-image]`, { opacity: 0, duration: 5 }, "aaa")
      .to(`[data-hero-asset]`, { opacity: 0, duration: 5 }, "aaa")
      .to(`[data-hero-phone]`, { opacity: 1, duration: 7 }, "aaa")
      .to(`[data-hero-phone]`, { transform: "scale(1)", duration: 5 }, "+=0.8")
      .addPause("+=0.5")
      .to(`[data-hero-movie-flash]`, { opacity: 1, duration: 0.5 }, "flash")
      .to(`[data-hero-movie-area]`, { backgroundColor: `#FF6A00`, duration: 1, ease: "power1.inOut" }, "flash")
      .to(`[data-hero-phone]`, { opacity: 0, duration: 0 }, "flash+=0.5")
      .to(`[data-hero-mini-link]`, { top: "20%", duration: 2.5 })
      .set(`[data-hero-photo="1"]`, {top: "30%", opacity: 1, duration: 0 }, "print")
      .to(`[data-hero-mini-link]`, { top: "25%", duration: 3 }, "print")
      .to(`[data-hero-heading]`, { opacity: 1, duration: 1 }, "+=0.5")
      .to(`[data-hero-photo="1"]`, { top: "1.5%", transform: "translateX(0)" }, "photo")
      .to(`[data-hero-photo="3"]`, { opacity: 1, rotate: -12, translate: "-137% -42%" }, "photo")
      .to(`[data-hero-photo="2"]`, { opacity: 1, rotate: 12, translate: "120% -42%" }, "<=0.4")
      .addPause("+=3");
    }

    if (triggerElement.matches("[data-simple-print-trigger]")) {
      const animation = gsapWithCSS.timeline({ defaults: { duration: 0.3 }, paused: true })
        .set(`[data-simple-print]`, { opacity: 0 })
        .set(`[data-simple-print="01"], [data-simple-print="04"]`, { y: 20 })
        .set(`[data-simple-print="03"]`, { maskPosition: "-100% 100%", opacity: 1 })
        .set(`[data-simple-print="02"] img`, { y: 360 })
        .to(`[data-simple-print="01"], [data-simple-print="04"]`, { opacity: 1, y: 0 })
        .to(`[data-simple-print="03"]`, { maskPosition: "0% 100%", ease: "none" })
        .to(`[data-simple-print="02"]`, { opacity: 1 })
        .to(`[data-simple-print="02"] img`, { y: 0, duration: 0.4 }, "<");
      ScrollTrigger.create({
        trigger: triggerElement, start: "top 70%", once: true,
        onEnter: () => { animation.play(); }
      });
    }

    if (triggerElement.matches(`[data-camera-trigger]`)) {
      const tilt = 10;
      ScrollTrigger.create({
        trigger: triggerElement, start: "top 70%", once: true,
        onEnter: () => {
          gsapWithCSS.timeline({ repeat: -1, defaults: { duration: 1 } })
            .set(`[data-camera="front-arrow"]`, { opacity: 0 })
            .set(`[data-camera="body"]`, { rotate: tilt, transformOrigin: "50% 70%" })
            .to(`[data-camera="front-arrow"]`, { opacity: 1 }, "+=0.5")
            .to(`[data-camera="back-arrow"]`, { opacity: 0 }, "<")
            .to(`[data-camera="image"] img`, { scale: 1.5 }, "<")
            .to(`[data-camera="body"]`, { rotate: -tilt }, "<")
            .to(`[data-camera="back-arrow"]`, { opacity: 1 }, "+=0.5")
            .to(`[data-camera="front-arrow"]`, { opacity: 0 }, "<")
            .to(`[data-camera="image"] img`, { scale: 1 }, "<")
            .to(`[data-camera="body"]`, { rotate: tilt }, "<");
        }
      });
    }

    if (triggerElement.matches(`[data-air-studio-parallax-trigger]`)) {
      const parallaxLayers = [
        { selector: "back", from: "5%", to: "-5%" },
        { selector: "main", from: "15%", to: "-15%" },
        { selector: "front", from: "25%", to: "-25%" },
        { selector: "photo", from: "12%", to: "-12%" }
      ];
      parallaxLayers.forEach(({ selector, from, to }) => {
        gsapWithCSS.fromTo(`[data-air-studio-parallax="${selector}"]`,
          { y: () => from },
          {
            y: () => to,
            scrollTrigger: {
              trigger: triggerElement, scrub: 0.2,
              start: "50% bottom", end: "50% top",
              invalidateOnRefresh: true
            }
          }
        );
      });
    }

    if (triggerElement.matches(`[data-click-to-collage]`)) {
      gsapWithCSS.timeline({
        defaults: { duration: 0.1 },
        scrollTrigger: {
          trigger: triggerElement, start: "top 80%", end: "bottom top",
          invalidateOnRefresh: true, once: true
        }
      })
      .set(`[data-count-image]`, { display: "block" })
      .to(`[data-result-image="1"]`, { opacity: 1 }, "+=0.95")
      .to(`[data-result-image="2"]`, { opacity: 1 })
      .to(`[data-result-image="3"]`, { opacity: 1 })
      .to(`[data-result-image="4"]`, { opacity: 1 })
      .to(`[data-result-image="5"]`, { opacity: 1 }, "+=0.1")
      .to(`[data-result-image="6"]`, { opacity: 1 }, "+=0.15")
      .to(`[data-result-title]`, { opacity: 1, duration: 0.3 })
      .to(`[data-count-sample]`, { opacity: 1, duration: 0.3 });
    }

    // if (triggerElement.matches(`body`)) {
    //   gsapWithCSS.fromTo("[data-menu-button]",
    //     { autoAlpha: 0 },
    //     {
    //       autoAlpha: 1,
    //       scrollTrigger: {
    //         trigger: triggerElement, start: "100px", end: "bottom bottom",
    //         toggleActions: "play none none reverse"
    //       }
    //     }
    //   );
    // }

    if (triggerElement.matches(`[data-photo]`)) {
      const rowGap = 40;
      const transform = () => {
        triggerElement?.querySelectorAll("[data-photo-image]").forEach((img, index) => {
          const colNum = index % 7 + 1;
          const columnOption = index > 13 ? `translateY(calc(100% + ${rowGap}px))` :
                               index < 7 ? `translateY(calc(-100% + -${rowGap}px))` : "";
          const rowMap = {
            1: "translateX(calc(-300% - 110px)) translateZ(15px) rotateY(6deg)",
            2: "translateX(calc(-200% - 75px)) translateZ(-4px) rotateY(4deg)",
            3: "translateX(calc(-100% - 40px)) translateZ(-16px) rotateY(2deg)",
            4: "translateZ(-20px)",
            5: "translateX(calc(100% + 40px)) translateZ(-16px) rotateY(-2deg)",
            6: "translateX(calc(200% + 75px)) translateZ(-4px) rotateY(-4deg)",
            7: "translateX(calc(300% + 110px)) translateZ(15px) rotateY(-6deg)"
          };
          img.setAttribute("style", `transform:${columnOption} ${rowMap[colNum]}`);
        });
      };
      ScrollTrigger.create({
        trigger: triggerElement,
        onEnter: () => { transform(); },
        start: "50% bottom", end: "40% 40%", once: true
      });
    }
  });
});

// ===== Film Animation =====
function init_animation() {
  var camera = $('.film-anim-camera');
  var cameraFlash = $('.film-anim-camera-flash');
  var film = $('.film-anim-film');
  var filmFrame = $('.film-anim-film-frame');

  var circle = document.querySelector('.progress-ring__circle');
  if (!circle) {
    console.error('Progress ring circle element not found');
    return;
  }

  var radius = circle.r.baseVal.value;
  var circumference = radius * 2 * Math.PI;
  circle.style.strokeDasharray = `${circumference} ${circumference}`;
  circle.style.strokeDashoffset = `${circumference}`;

  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({ ease: "none", duration: 2 });
  // Let the timeline fully own every title/desc state so the swaps are reliable
  // (don't depend on the inline opacity/visibility baked into the HTML).
  gsap.set('.film-anim-title-1', { autoAlpha: 1 });
  gsap.set(['.film-anim-desc-1', '.film-anim-title-2', '.film-anim-desc-2', '.film-anim-title-3'], { autoAlpha: 0 });
  gsap.set(film, {
    autoAlpha: 0,
    bottom: "20px"
  });

  gsap.set(filmFrame, {
    autoAlpha: 0,
    bottom: "20px"
  });
  gsap.set(camera, {
    bottom: "0",
    opacity: 1
  });
  var progressProxy = { value: 0 };

  gsap.timeline({
    scrollTrigger: {
      trigger: ".film-animation",
      pin: false,
      start: "top top",
      end: "bottom bottom",
      scrub: true
    }
  })
  .to('.film-anim-desc-1', { autoAlpha: 1, duration: 1 })
  .to(cameraFlash, { opacity: 1, duration: 0.1 })
  .to(cameraFlash, { opacity: 0, duration: 0.5 })
  // hold so "Take..." stays readable before swapping to scene 2
  .to({}, { duration: 1.5 })
  .to('.film-anim-title-1', { autoAlpha: 0, duration: 1 })
  .to('.film-anim-desc-1', { autoAlpha: 0, duration: 1 }, "<")
  .to('.film-anim-continue', { autoAlpha: 0, duration: 1 }, "<")
  // .to('.film-anim-scroll', { autoAlpha: 0, duration: 1 }, "<")
  .to('.film-anim-title-2', { autoAlpha: 1, duration: 1.5 })
  // desc-2 fades in WITH title-2 (synced pair), not after it
  .to('.film-anim-desc-2', { autoAlpha: 1, duration: 1.5 }, "<")
  // film + frame just fade in at their lower start position (-10%), no rise yet
  .to(film, {
    autoAlpha: 1,
    duration: 1
  }, "<")

  .to(filmFrame, {
    autoAlpha: 1,
    duration: 1
  }, "<")
  .to(camera, {
    bottom: "-100%",
    opacity: 0,
    duration: 1
  })

  // as the camera drops away, film + frame rise from -10% straight to their
  // final resting spot (0) in a single motion — no 20% overshoot
  .to(film, {
    bottom: "0",
    duration: 1
  }, "<")

  .to(filmFrame, {
    bottom: "0",
    duration: 1
  }, "<")
  .to('.progress-ring-wrapper', { autoAlpha: 1, duration: 1 })
  .to('.film-anim-film-image-1', { autoAlpha: 1, duration: 2 })
  .to(progressProxy, {
    value: 1, duration: 2,
    onUpdate: function () { update_progress_ring(progressProxy.value); }
  }, "<")
  .to('.film-anim-film-shine', { autoAlpha: 1, duration: 0.5 })
  .to('.film-anim-film-shine', { backgroundPosition: "500px 0" })
  .to('.film-anim-film-shine', { autoAlpha: 0, duration: 0 })
  .to('.progress-ring-wrapper', { autoAlpha: 0, duration: 1 })
  .to('.film-anim-title-2', { autoAlpha: 0, duration: 1 }, "<")
  .to('.film-anim-desc-2', { autoAlpha: 0, duration: 1 }, "<")
  .to('.film-anim-title-3', { autoAlpha: 1, duration: 1.5 })
  // hold so "Give some love" stays on screen through the end of the scroll
  .to({}, { duration: 4 })
  // .to('.film-anim-title-3', { autoAlpha: 0, duration: 1 }, "+=1")
  // .to(film, { autoAlpha: 0, duration: 1 }, "<")
  // .to(filmFrame, { autoAlpha: 0, duration: 1 }, "<");
  // .to('.film-anim-title-4', { autoAlpha: 1, duration: 1 })
  // .to('.film-anim-film-square', { autoAlpha: 1, duration: 1 }, "<")
  // .to('.film-anim-title-4', { autoAlpha: 0, duration: 1 }, "+=1")
  // .to('.film-anim-film-square', { autoAlpha: 0, duration: 1 }, "<")
  // .to('.film-anim-title-5', { autoAlpha: 1, duration: 1 })
  // .to('.film-anim-film-wide', { autoAlpha: 1, duration: 1 }, "<");

  function update_progress_ring(progress) {
    var offset = circumference - progress * circumference;
    circle.style.strokeDashoffset = offset;
    var percent = (progress * 90).toFixed(0);
    $('.progress-ring-time').text(percent);
  }
}
